/* ============================================================
   product.js — Product Detail Page interactions.

   The static build's version of this file fetched catalog.json and
   built the ENTIRE PDP (gallery, info, variants, description, paired
   products, reviews, SEO tags) from scratch client-side. On Shopify all
   of that is already server-rendered by sections/main-product.liquid
   with real product/variant data — this file only wires up the
   interactive bits Liquid can't: gallery navigation, the fit-tab/size-
   pill variant picker (updating the real hidden variant id input),
   quantity, wishlist, and intercepting the real product form to use
   the Ajax Cart drawer instead of a full-page reload.
   ============================================================ */
(function () {
  "use strict";

  var form = document.querySelector("[data-pdp-form]");
  if (!form) return;

  var state = { activeImage: 0, size: null };

  var variantsData = [];
  var variantsScript = document.querySelector("[data-pdp-variants]");
  if (variantsScript) {
    try { variantsData = JSON.parse(variantsScript.textContent); } catch (e) { variantsData = []; }
  }

  function fmtMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.GHONCHE_MONEY_FORMAT);
    }
    return "Rs. " + Math.round((Number(cents) || 0) / 100).toLocaleString("en-PK");
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var thumbsWrap = document.querySelector("[data-pdp-thumbs]");
    var mainImg = document.querySelector("[data-pdp-main-img]");
    var countEl = document.querySelector("[data-pdp-count]");
    var thumbs = document.querySelectorAll("[data-pdp-thumb]");
    var dots = document.querySelectorAll("[data-pdp-dot]");
    var total = thumbs.length;
    if (!mainImg || !total) return;

    var fullSrcMap = {};
    thumbs.forEach(function (t, i) {
      var img = t.querySelector("img");
      if (img) fullSrcMap[i] = img.src.replace(/width=\d+/, "width=800");
    });

    function setActive(i) {
      state.activeImage = i;
      if (fullSrcMap[i]) { mainImg.src = fullSrcMap[i]; mainImg.removeAttribute("srcset"); }
      if (countEl) countEl.textContent = (i + 1) + " / " + total;
      thumbs.forEach(function (t) { t.classList.toggle("is-active", Number(t.dataset.pdpThumb) === i); });
      dots.forEach(function (d) { d.classList.toggle("is-active", Number(d.dataset.pdpDot) === i); });
    }

    if (thumbsWrap) thumbsWrap.addEventListener("click", function (e) {
      var t = e.target.closest("[data-pdp-thumb]");
      if (t) setActive(Number(t.dataset.pdpThumb));
    });
    var prevBtn = document.querySelector("[data-pdp-prev]");
    var nextBtn = document.querySelector("[data-pdp-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { setActive((state.activeImage - 1 + total) % total); });
    if (nextBtn) nextBtn.addEventListener("click", function () { setActive((state.activeImage + 1) % total); });
    if (total < 2) { if (prevBtn) prevBtn.hidden = true; if (nextBtn) nextBtn.hidden = true; }

    var stage = document.querySelector("[data-pdp-main-wrap]");
    if (stage) {
      var startX = null;
      stage.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener("touchend", function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) setActive((state.activeImage + (dx < 0 ? 1 : -1) + total) % total);
        startX = null;
      }, { passive: true });
    }
  }

  /* ---------- Variant picker (fit tabs + size pills → real variant id) ---------- */
  function initVariants() {
    var variantInput = form.querySelector("[data-pdp-variant-id]");
    var fitTabsWrap = document.querySelector("[data-pdp-fit-tabs]");
    var pillsWrap = document.querySelector("[data-pdp-size-pills]");
    if (!pillsWrap) return;

    if (fitTabsWrap) {
      fitTabsWrap.addEventListener("click", function (e) {
        var t = e.target.closest("[data-pdp-fit]");
        if (!t) return;
        fitTabsWrap.querySelectorAll("[data-pdp-fit]").forEach(function (b) { b.classList.remove("is-active"); });
        t.classList.add("is-active");
        var fit = t.dataset.pdpFit;
        pillsWrap.querySelectorAll("[data-pdp-fit-group]").forEach(function (p) {
          p.hidden = p.dataset.pdpFitGroup !== fit;
          p.classList.remove("is-active");
        });
        state.size = null;
        variantInput.value = "";
      });
    }

    pillsWrap.addEventListener("click", function (e) {
      var t = e.target.closest("[data-pdp-size]");
      if (!t || t.disabled) return;
      pillsWrap.querySelectorAll("[data-pdp-size]").forEach(function (p) { p.classList.remove("is-active"); });
      t.classList.add("is-active");
      state.size = t.dataset.pdpSize;
      if (t.dataset.variantId) updatePrice(t.dataset.variantId);
      if (variantInput) variantInput.value = t.dataset.variantId || "";
      var note = document.querySelector("[data-pdp-buy-note]");
      if (note) note.hidden = true;
    });

    /* Size Guide popup: responsive on both tiers via the same
       .pdp-sizemodal CSS already built for it - a bottom sheet under
       640px, a centered dialog at 640px+. Both "Size Guide" links next
       to Select Size (fit-tabs layout and plain-options layout each
       render their own) open it. */
    var sizeModal = document.querySelector("[data-pdp-sizemodal]");
    if (sizeModal) {
      function openSizeModal() {
        sizeModal.hidden = false;
        if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(true);
      }
      function closeSizeModal() {
        sizeModal.hidden = true;
        if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(false);
      }
      document.querySelectorAll("[data-pdp-sizeguide-open]").forEach(function (btn) {
        btn.addEventListener("click", openSizeModal);
      });
      sizeModal.querySelectorAll("[data-pdp-sizemodal-close]").forEach(function (btn) {
        btn.addEventListener("click", closeSizeModal);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !sizeModal.hidden) closeSizeModal();
      });
    }
  }

  function updatePrice(variantId) {
    var variant = variantsData.filter(function (v) { return String(v.id) === String(variantId); })[0];
    if (!variant) return;
    var priceNow = document.querySelector("[data-pdp-price-now]");
    var priceWas = document.querySelector("[data-pdp-price-was]");
    var priceOff = document.querySelector("[data-pdp-price-off]");
    var badgeEl = document.querySelector("[data-pdp-badge]");
    var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (priceNow) priceNow.textContent = fmtMoney(variant.price);
    if (hasDiscount) {
      var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      if (priceWas) { priceWas.hidden = false; priceWas.textContent = fmtMoney(variant.compare_at_price); }
      if (priceOff) { priceOff.hidden = false; priceOff.textContent = pct + "% OFF"; }
      if (badgeEl) { badgeEl.hidden = false; badgeEl.textContent = pct + "% OFF"; }
    } else {
      if (priceWas) priceWas.hidden = true;
      if (priceOff) priceOff.hidden = true;
      if (badgeEl) badgeEl.hidden = true;
    }
    var addBtn = document.querySelector("[data-pdp-add]");
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.lastChild.textContent = variant.available ? "Add to Bag" : "Sold Out";
    }
  }

  /* ---------- Quantity ---------- */
  function initQty() {
    var qtyVal = document.querySelector("[data-pdp-qty-val]");
    var qtyInput = document.querySelector("[data-pdp-qty-input]");
    var qty = 1;
    var dec = document.querySelector("[data-pdp-qty-dec]");
    var inc = document.querySelector("[data-pdp-qty-inc]");
    if (dec) dec.addEventListener("click", function () {
      qty = Math.max(1, qty - 1);
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });
    if (inc) inc.addEventListener("click", function () {
      qty = qty + 1;
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });
  }

  /* ---------- Add to bag (real form, AJAX-enhanced) ---------- */
  function initForm() {
    var variantInput = form.querySelector("[data-pdp-variant-id]");
    var hasSizePills = document.querySelectorAll("[data-pdp-size]").length > 0;

    form.addEventListener("submit", function (e) {
      if (hasSizePills && (!variantInput || !variantInput.value) && !state.size) {
        e.preventDefault();
        var note = document.querySelector("[data-pdp-buy-note]");
        if (note) note.hidden = false;
        var wrap = document.querySelector("[data-pdp-variant]");
        if (wrap) wrap.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (window.GhoncheCart && variantInput && variantInput.value) {
        e.preventDefault();
        var qtyInput = form.querySelector("[data-pdp-qty-input]") || form.querySelector('[name="quantity"]');
        var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;
        window.GhoncheCart.addToCart(variantInput.value, qty).then(function () {
          window.GhoncheCart.openDrawer();
        });
      }
    });
  }

  /* ---------- Wishlist heart ---------- */
  function initWishlist() {
    var wishBtn = document.querySelector("[data-pdp-wish]");
    if (!wishBtn) return;
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var handle = m ? m[1] : "";
    if (!handle) return;

    function getList() {
      try { return JSON.parse(localStorage.getItem("ghonche_wishlist") || "[]"); } catch (e) { return []; }
    }
    var isSaved = getList().indexOf(handle) !== -1;
    wishBtn.setAttribute("aria-pressed", String(isSaved));

    wishBtn.addEventListener("click", function () {
      var on = wishBtn.getAttribute("aria-pressed") === "true";
      try {
        var list = getList();
        if (on) list = list.filter(function (h) { return h !== handle; });
        else list.push(handle);
        localStorage.setItem("ghonche_wishlist", JSON.stringify(list));
      } catch (e) {}
      wishBtn.setAttribute("aria-pressed", String(!on));
      if (window.GhoncheCart) window.GhoncheCart.toast(!on ? "Saved to wishlist" : "Removed from wishlist");
    });
  }

  /* ---------- Paired Well With "ADD +" ---------- */
  function initPaired() {
    var grid = document.querySelector("[data-pdp-paired-grid]");
    if (!grid) return;
    grid.addEventListener("click", function (e) {
      var t = e.target.closest("[data-pdp-paired-add]");
      if (!t || !window.GhoncheCart) return;
      window.GhoncheCart.addToCart(t.dataset.variantId, 1).then(function () {
        window.GhoncheCart.openDrawer();
      });
    });

    /* Dots reflect the scroller's actual scroll position (native
       scroll-snap drives the motion, not JS) - a scroll listener just
       maps scrollLeft back to the nearest card index. Clicking a dot
       scrolls to that card. Re-queried (not a one-time snapshot) so it
       can be re-bound after applyPairedOverride() replaces the grid. */
    var syncTimer = null;
    function bindDots() {
      var dots = grid.parentElement.querySelectorAll("[data-pdp-paired-dot]");
      if (!dots.length) return;
      function syncActiveDot() {
        var idx = Math.round(grid.scrollLeft / grid.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
      }
      grid.addEventListener("scroll", function () {
        if (syncTimer) clearTimeout(syncTimer);
        syncTimer = setTimeout(syncActiveDot, 80);
      });
      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          grid.scrollTo({ left: i * grid.clientWidth, behavior: "smooth" });
        });
      });
    }
    bindDots();
    window.__ghoncheRebindPairedDots = bindDots;
  }

  /* ---------- Global overrides (Header section -> product-picker
     blocks, no metafields/metaobjects): let a merchant assign the same
     "Add More Save More" picks or Size Guide to any product/collection
     from ONE place, without needing a separate alternate template per
     product. A product's own LOCAL config (data-has-local="true", set
     from this product's own template blocks) always wins over these -
     so the existing Aelin/Cisel/Sybil size-guide templates keep working
     untouched. These are pure additions on top of the server-rendered
     fallback; if nothing matches, nothing changes on the page. ---------- */
  function matchOverride(list, handle, collections) {
    var match = null;
    (list || []).forEach(function (entry) {
      if (match) return;
      if (entry.handles.indexOf(handle) !== -1) { match = entry; return; }
      if (entry.collection && collections.indexOf(entry.collection) !== -1) match = entry;
    });
    return match;
  }

  function getProductContext() {
    var stage = document.querySelector("[data-product-handle]");
    if (!stage) return null;
    return {
      handle: stage.getAttribute("data-product-handle") || "",
      collections: (stage.getAttribute("data-collections") || "").split(",").filter(Boolean)
    };
  }

  function applyPairedOverride() {
    var section = document.querySelector("[data-pdp-paired-section]");
    var grid = document.querySelector("[data-pdp-paired-grid]");
    var ctx = getProductContext();
    if (!section || !grid || !ctx || !window.GhonchePairedOverrides) return;
    if (section.dataset.hasLocal === "true") return;

    var match = matchOverride(window.GhonchePairedOverrides, ctx.handle, ctx.collections);
    if (!match || !match.items.length) return;

    Promise.all(match.items.slice(0, 4).map(function (h) {
      return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;

      grid.innerHTML = products.map(function (p) {
        var variant = p.variants[0];
        var img = p.featured_image || "";
        if (img.indexOf("http") !== 0) img = "https:" + img;
        var sep = img.indexOf("?") === -1 ? "?" : "&";
        var imgSized = img + sep + "width=300";
        var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
        var title = String(p.title).replace(/"/g, "&quot;");
        return (
          '<article class="pdp-paired-mini">' +
            '<a class="pdp-paired-mini__thumb" href="/products/' + p.handle + '">' +
              '<img src="' + imgSized + '" alt="' + title + '" width="180" height="240" loading="lazy">' +
            "</a>" +
            '<p class="pdp-paired-mini__rating" data-rating-proof></p>' +
            '<div class="pdp-paired-mini__info">' +
              "<h4><a href=\"/products/" + p.handle + '">' + p.title + "</a></h4>" +
              '<p class="pdp-paired-mini__price"><strong>' + fmtMoney(variant.price) + "</strong>" +
              (hasDiscount ? "<s>" + fmtMoney(variant.compare_at_price) + "</s>" : "") +
              "</p>" +
            "</div>" +
            '<button type="button" class="pdp-paired-mini__add" data-pdp-paired-add aria-label="Add ' + title + ' to bag" data-handle="' + p.handle + '" data-variant-id="' + variant.id + '" data-title="' + title + '" data-price="' + variant.price + '" data-img="' + imgSized + '">ADD +</button>' +
          "</article>"
        );
      }).join("");

      var dotsWrap = section.querySelector("[data-pdp-paired-dots]");
      if (products.length > 1) {
        var dotsHtml = products.map(function (_, i) {
          return '<span class="pdp-paired-inline__dot' + (i === 0 ? " is-active" : "") + '" data-pdp-paired-dot="' + i + '"></span>';
        }).join("");
        if (!dotsWrap) {
          dotsWrap = document.createElement("div");
          dotsWrap.className = "pdp-paired-inline__dots";
          dotsWrap.setAttribute("data-pdp-paired-dots", "");
          section.appendChild(dotsWrap);
        }
        dotsWrap.innerHTML = dotsHtml;
      } else if (dotsWrap) {
        dotsWrap.innerHTML = "";
      }

      section.hidden = false;
      if (window.__ghoncheRebindPairedDots) window.__ghoncheRebindPairedDots();
      if (window.GhoncheRatings && window.GhoncheRatings.applyStarsFromProof) window.GhoncheRatings.applyStarsFromProof();
    });
  }

  function applySizeGuideOverride() {
    var accordion = document.querySelector("[data-pdp-sizeguide-accordion]");
    var ctx = getProductContext();
    if (!accordion || !ctx || !window.GhoncheSizeGuideOverrides) return;
    if (accordion.dataset.hasLocal === "true") return;

    var match = matchOverride(window.GhoncheSizeGuideOverrides, ctx.handle, ctx.collections);
    if (!match || (!match.image && (!match.rows || !match.rows.length))) return;

    var html;
    if (match.image) {
      html = '<div class="pdp-sizechart pdp-sizechart--image"><img src="' + match.image + '" alt="Size guide" loading="lazy"></div>';
    } else {
      var cols = match.cols || [];
      var theadCells = "<th>" + (cols[0] || "Size") + "</th>";
      var i;
      for (i = 1; i <= 4; i++) { if (cols[i]) theadCells += "<th>" + cols[i] + "</th>"; }
      var bodyRows = match.rows.map(function (row) {
        var cells = "<td>" + (row.label || "") + "</td>";
        for (var j = 1; j <= 4; j++) { if (cols[j]) cells += "<td>" + (row.values[j - 1] || "") + "</td>"; }
        return "<tr>" + cells + "</tr>";
      }).join("");
      html = '<div class="pdp-sizechart"><table><thead><tr>' + theadCells + "</tr></thead><tbody>" + bodyRows + "</tbody></table></div>";
    }

    document.querySelectorAll("[data-pdp-sizeguide-body]").forEach(function (el) { el.innerHTML = html; });
    accordion.hidden = false;
    document.querySelectorAll("[data-pdp-sizeguide-open]").forEach(function (btn) { btn.hidden = false; });
  }

  initGallery();
  initVariants();
  initQty();
  initForm();
  initWishlist();
  applyPairedOverride();
  applySizeGuideOverride();
  initPaired();
})();
